import { useState } from "react";
import { Link, NavLink } from 'react-router-dom'
import logo from "../images/Logo-long.png"
// import logo from "../images/Logo-rnd.png"
import {links} from '../data'
import { FaBarsStaggered } from "react-icons/fa6";
import { MdClose } from "react-icons/md";
import './navbar.css'

const Navbar = () => {
  const [isNavShowing, setIsNavShowing] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);

  const handleMouseEnter = (index) => {
    setActiveDropdown(index);
  };

  const handleMouseLeave = () => {
    setActiveDropdown(null);
  };

  return (
    <nav className="navbar">
      <div className='container nav__container'>
        <Link to="/" className='logo' onClick={() => setIsNavShowing(false)}>
          <img src={logo} alt="Nav logo" />
        </Link>
        <ul className={`nav__links ${isNavShowing ? 'show__nav' : 'hide__nav'}`}>
          {links.map(({name, path, subLinks}, index) => {
            return (
              <li 
                key={index} 
                onMouseEnter={() => handleMouseEnter(index)}
                onMouseLeave={handleMouseLeave}
                className="nav-item"
              >
                <NavLink 
                  to={path} 
                  className={({isActive}) => isActive ? 'active-nav' : ''}
                  onClick={() => setIsNavShowing(prev => !prev)}
                >
                  {name}
                </NavLink>
                {subLinks && subLinks.length > 0 && activeDropdown === index && (
                  <ul className="dropdown-menu">
                    {subLinks.map((subLink, subIndex) => (
                      <li key={subIndex}>
                        <NavLink 
                          to={subLink.path} 
                          className={({isActive}) => isActive ? 'active-nav' : ''}
                          onClick={() => setIsNavShowing(prev => !prev)}
                        >
                          {subLink.name}
                        </NavLink>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            )
          })}
        </ul>
        <button className="nav__toggle-btn" onClick={() => setIsNavShowing(prev => !prev)}>
          {isNavShowing ? <MdClose/> : <FaBarsStaggered/>}
        </button>
      </div>
    </nav>
  )
}

export default Navbar
